import styled from "styled-components";

export const RequiredContainer = styled.span `
    color: ${props => props.theme.colors.danger.main}
`